import { useInfiniteQuery } from "@tanstack/react-query";
import { useHookstate } from "@hookstate/core";
import {
  GET_FEED_SUGGESTION_QUERY_KEY,
  getFeedSuggestion,
} from "../api/suggestionFeedApi";
import { FeedItem } from "../types";
import { feedModeStore } from "../../../hookstate/feedModeStore";

export function useSuggestionFeed(seed: string | null) {
  const mode = useHookstate(feedModeStore).get();

  const query = useInfiniteQuery({
    // Mode in the key makes the toggle automatically refetch from the top.
    queryKey: [...GET_FEED_SUGGESTION_QUERY_KEY, seed ?? "__default__", mode],
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam }) => {
      const response = await getFeedSuggestion(seed, pageParam, 12, mode);
      return response.data.payload.results;
    },
    getNextPageParam: (lastPage) => lastPage.cursor_next ?? undefined,
    refetchOnWindowFocus: false,
  });

  const items: FeedItem[] =
    query.data?.pages.flatMap((page) => page.items) ?? [];

  return {
    items,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage ?? false,
    fetchNextPage: query.fetchNextPage,
    error: query.error,
  };
}
